'use client'

import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Row } from '@repo/ui/components'
import { useParams } from 'next/navigation'

export const BalanceAssetNavbar = () => {
  const { t } = useTranslate()
  const { id } = useParams()
  return (
    <Row className='fixed bottom-0 left-0 w-full right-0 justify-between h-fit gap-md p-md bg-neutral-surface-light rounded-t-sm border-t  border-neutral-surface-dark shadow-sm'>
      {id !== 'MALEK' && (
        <ButtonLink
          href={`/assets/${id}?type=sell`}
          width='full'
          variant='ghost'
          color='negative'
          className='w-1/2'
        >
          {t('walletPage_sell_in_market')}
        </ButtonLink>
      )}
      <ButtonLink
        href={`/quick-trade?projectId=${id}&type=sell`}
        width='full'
        className={id === 'MALEK' ? 'w-full' : 'w-1/2'}
        variant='fill'
        color='negative'
      >
        {t('walletPage_sell_in_market_instant')}
      </ButtonLink>
    </Row>
  )
}
